// js for tutorial in free SOPHIA area
import 'account/sign_up_overlay'
import 'tutorials/publishing'
import 'tutorials/publishing_state'
import 'tutorials/show'
import KeyboardShortcutBlocking from 'assessment_player/keyboard_shortcut_blocking'

KeyboardShortcutBlocking.setupKeyboardShortcutBlocking()
